import type { MatchEvent } from '@/types';

/**
 * Timelines by fixture id, shaped exactly like the API.
 *
 * Only played fixtures have events; an unplayed one is absent here and returns
 * an empty list, which is what the API does too.
 */
export const MOCK_MATCH_EVENTS: Readonly<Record<number, readonly MatchEvent[]>> = {
  900001: [
    { minute: 12, type: 'goal', playerName: 'Marcus Sterling', teamId: 900101 },
    { minute: 45, type: 'goal', playerName: 'Rafael Costa', teamId: 900102 },
    { minute: 78, type: 'goal', playerName: 'Noah Bennett', teamId: 900101 },
  ],
  900002: [
    { minute: 33, type: 'goal', playerName: 'Nico Silva', teamId: 900102 },
    { minute: 67, type: 'goal', playerName: 'Samuel Cole', teamId: 900101 },
  ],
  900003: [
    { minute: 21, type: 'goal', playerName: 'Marcus Sterling', teamId: 900101 },
    { minute: 39, type: 'yellowcard', playerName: 'Owen Price', teamId: 900102 },
    { minute: 54, type: 'goal', playerName: 'Noah Bennett', teamId: 900101 },
    { minute: 62, type: 'goal', playerName: 'Rafael Costa', teamId: 900102 },
  ],
};
